import t from '@jetshop/intl';
import Accordion from '@jetshop/ui/Accordion/Accordion';
import ProductSpecifications from '@jetshop/ui/ProductSpecifications/ProductSpecifications';
import React, { Fragment } from 'react';
import styled from 'react-emotion';
// import { LipscoreProductReview } from '../Lipscore/LipscoreProductReview';
// import { LipscoreQuestions } from '../Lipscore/LipscoreQuestions';
import {
  ProductSection as UIProductSection,
  SectionHeading,
} from './ProductInfo';

const Description = styled('article')`
  line-height: 25px;
`;

const ProductSection = styled(UIProductSection)`
  border-bottom: 1px solid #e8e8e8;
  padding: 1rem 0;
  margin: 1rem 0;
  font-size: 0.875rem;
  ${SectionHeading} {
    display: flex;
    justify-items: space-between;
    align-items: center;
    margin-bottom: 0;
    span:first-child {
      font-size: 1rem;
      text-transform: none;
    }
    + * > :first-child {
      margin-top: 1rem;
    }
  }
`;

const SpecField = styled('div')`
  font-size: 14px;
  display: block;
  padding: 8px 10px;
  line-height: 1.2;
  padding: 5px 10px;
  span {
    font-weight: bold;
    margin-right: 2px;
  }

  &:nth-of-type(odd) {
    background: #f3f3f3;
  }
`;

const IndicatorIcon = styled('span')`
  margin-left: auto;
  font-size: 1.25rem;
`;
const AccordionIndicator = ({ isOpen }) => (
  <IndicatorIcon>{isOpen ? '-' : '+'}</IndicatorIcon>
);

const ProductInfoAccordion = ({ product, specs }) => (
  <Accordion single initialOpenIndexes={[1]}>
    {({ openIndexes, handleClick, AccordionContent }) => {
      return (
        <Fragment>
          <ProductSection>
            <SectionHeading onClick={() => handleClick(1)}>
              <span>{t('Product description')}</span>
              <AccordionIndicator isOpen={openIndexes.includes(1)} />
            </SectionHeading>
            <AccordionContent isOpen={openIndexes.includes(1)}>
              <Description
                dangerouslySetInnerHTML={{
                  __html: product.shortDescription,
                }}
              />
            </AccordionContent>
          </ProductSection>
          {specs && specs.listValues.length > 0 ? (
            <ProductSection>
              <SectionHeading onClick={() => handleClick(2)}>
                <span>{t('Specifications')}</span>
                <AccordionIndicator isOpen={openIndexes.includes(2)} />
              </SectionHeading>
              <AccordionContent isOpen={openIndexes.includes(2)}>
                {specs.listValues.map((value, index) => {
                  let title = value.split(' : ')[0];
                  let text = value.split(' : ')[1];
                  return (
                    <SpecField key={index}>
                      <span>{title}: </span>
                      {text}
                    </SpecField>
                  );
                })}
              </AccordionContent>
            </ProductSection>
          ) : null}
          {/* <ProductSection>
          <SectionHeading onClick={() => handleClick(3)}>
            <span>{t('Ratings & Reviews')}</span>
            <AccordionIndicator isOpen={openIndexes.includes(3)} />
          </SectionHeading>
          <AccordionContent isOpen={openIndexes.includes(3)}>
            <LipscoreProductReview product={product} />
          </AccordionContent>
        </ProductSection>
        <ProductSection>
          <SectionHeading onClick={() => handleClick(4)}>
            <span>{t('Questions & Answers')}</span>
            <AccordionIndicator isOpen={openIndexes.includes(4)} />
          </SectionHeading>
          <AccordionContent isOpen={openIndexes.includes(4)}>
            <LipscoreQuestions product={product} />
          </AccordionContent>
        </ProductSection> */}
        </Fragment>
      );
    }}
  </Accordion>
);

export default ProductInfoAccordion;
